import styles from './profilePage.module.css';
// import AutoActionsTab from './tabs/AutoActionsTab/AutoActionsTab.tsx';
import CompletionModalWindow from '@components/modals/CompletionModalWindow';
import DataTab from './tabs/DataTab/DataTab.tsx';
import FinTab from './tabs/FinTab.tsx';
import Page from '@components/Page/Page';
import TopUpBalanceFormModalWindow from '@components/modals/TopUpBalanceFormModalWindow';
import useTab from '@hooks/useTab';
import WithdrawFundsFormModalWindow from './modals/WithdrawFundsFormModalWindow';
import { ButtonType } from '@components/Button';
import { Button } from '@components/Button';
import {
  checkBalanceReplenishment,
  checkPaymentLinkStatus,
  // getAutoActions,
  getWeChatWallets
} from '@api/apiClient/finance';
import { DataViewHandle } from '@containers/DataTable';
import { Modal } from '@components/Modal';
import { ReactElement, useRef, useState } from 'react';
import { TabsList, TabsContent } from '@components/Tabs/Tabs';
import { Tooltip } from '@components/new/Tooltip';
import { useMutation, useQuery } from 'react-query';
import { useProfile } from '@contexts/ProfileContext';
// import { useSellersCounter } from '@contexts/SellersCounterContext';
import { useTranslation } from 'react-i18next';

const ProfilePage = () => {
  const [balanceReplenishmentError, setBalanceReplenishmentError] = useState<string | undefined>(undefined);
  const [balanceReplenishmentInProcessed, setBalanceReplenishmentInProcessed] = useState<boolean>(false);
  const [isOpenCompletionWindow, setIsOpenCompletionWindow] = useState<boolean>(false);
  const [isOpenTopUpBalanceFormWindow, setIsOpenTopUpBalanceFormWindow] = useState<boolean>(false);
  const [isOpenWithdrawFundsFormWindow, setIsOpenWithdrawFundsFormWindow] = useState<boolean>(false);
  const [replenishmentAmount, setReplenishmentAmount] = useState<number>(0);

  const dataRef = useRef<DataViewHandle | null>(null);
  const { account, get } = useProfile();
  // const { sellersNotFound } = useSellersCounter();
  const { t } = useTranslation();

  const timeoutCheckBalance = useRef<number | null>(null);
  const timeoutCheckLink = useRef<number | null>(null);
  const timeoutCheckQr = useRef<number | null>(null);

  const wechatWallets = useQuery({
    queryKey: ['wechatWallets'],
    queryFn: () => getWeChatWallets(),
    retry: 1
  });

  // const {
  //   data: dataGetAutoActions,
  //   isFetching: isFetchingGetAutoActions,
  //   refetch: refetchGetAutoActions
  // } = useQuery({
  //   queryKey: ['getAutoActions'],
  //   queryFn: () => getAutoActions(),
  //   retry: 1,
  //   enabled: !sellersNotFound
  // });

  const checkBalanceReplenishmentMutation = useMutation({
    mutationFn: checkBalanceReplenishment
  });

  const checkPaymentLinkStatusMutation = useMutation({
    mutationFn: checkPaymentLinkStatus
  });

  const waitingBalanceReplenished = (id: string): void => {
    if (account?.region === 'CN') {
      timeoutCheckBalance.current = window.setTimeout(() => {
        checkBalanceReplenishmentMutation.mutate(id, {
          onSuccess: (data) => {
            if (data.isProcess) {
              if (!balanceReplenishmentInProcessed) setBalanceReplenishmentInProcessed(true);
              waitingBalanceReplenished(id);
            } else {
              if (balanceReplenishmentInProcessed) setBalanceReplenishmentInProcessed(false);
              if (data.isSuccess) {
                clearTimeout(timeoutCheckQr.current as number);
                get();
                setIsOpenCompletionWindow(true);
                setIsOpenTopUpBalanceFormWindow(false);
                setReplenishmentAmount(data.amount!);
              } else {
                if (data.errorCode) {
                  clearTimeout(timeoutCheckQr.current as number);
                  setBalanceReplenishmentError(data.errorCode);
                } else {
                  waitingBalanceReplenished(id);
                }
              }
            }
          }
        });
      }, 3000);
    }
    if (account?.region === 'TR') {
      if (!balanceReplenishmentInProcessed) setBalanceReplenishmentInProcessed(true);
      timeoutCheckBalance.current = window.setTimeout(() => {
        checkPaymentLinkStatusMutation.mutate(id, {
          onSuccess: (data) => {
            if (data.isPaid) {
              if (balanceReplenishmentInProcessed) setBalanceReplenishmentInProcessed(false);
              clearTimeout(timeoutCheckLink.current as number);
              get();
              setIsOpenCompletionWindow(true);
              setIsOpenTopUpBalanceFormWindow(false);
              setReplenishmentAmount(data.amount!);
            } else {
              waitingBalanceReplenished(id);
            }
          }
        });
      }, 3000);
    }
  };

  const setQrTimeout = (): void => {
    timeoutCheckQr.current = window.setTimeout(() => {
      setIsOpenTopUpBalanceFormWindow(false);
      clearTimeout(timeoutCheckBalance.current as number);
    }, 7200000);
  };

  const setLinkTimeout = (): void => {
    timeoutCheckLink.current = window.setTimeout(() => {
      setIsOpenTopUpBalanceFormWindow(false);
      clearTimeout(timeoutCheckBalance.current as number);
    }, 7200000);
  };

  const onCloseBalanceForm = (): void => {
    clearTimeout(timeoutCheckBalance.current as number);
    clearTimeout(timeoutCheckLink.current as number);
    clearTimeout(timeoutCheckQr.current as number);
    setIsOpenTopUpBalanceFormWindow(false);
  };

  const tabs = [
    {
      id: 'dataTab',
      title: t('profilePage.dataTab'),
      content: <DataTab refetchWallets={wechatWallets.refetch} />
    },
    {
      id: 'finTab',
      title: t('profilePage.finTab'),
      content: (
          <FinTab
              dataRef={dataRef}
              wechatWallets={wechatWallets.data?.items}
              refetchWallets={wechatWallets.refetch}
          />
      )
    },
    // ...((account?.region === 'CN' ? (account?.isTestUser && account?.features.customerReturnsResales) : true)
    //     && dataGetAutoActions?.autoActions.length
    //         ? [{
    //           id: 'autoActionsTab',
    //           title: t('profilePage.autoActionsTab'),
    //           content: (
    //               <AutoActionsTab
    //                   dataGetAutoActions={dataGetAutoActions!}
    //                   handlerRefetchGetAutoActions={refetchGetAutoActions}
    //                   isFetchingGetAutoActions={isFetchingGetAutoActions}
    //                   sellersNotFound={sellersNotFound}
    //               />
    //           )
    //         }]
    //         : []
    // )
  ];
  const { activeTab, setActiveTab } = useTab(tabs);

  const conditionForBtn: boolean =
      wechatWallets.data?.items.length
          ? account!.hasActiveWithdrawal
          : true;

  const textForTooltip: string =
      wechatWallets.data?.items.length
          ? account!.hasActiveWithdrawal
              ? t('profilePage.actionTooltip2')
              : ''
          : t('profilePage.actionTooltip1');

  const topUpBalanceBtn: ReactElement =
      <Button
          onClick={() => setIsOpenTopUpBalanceFormWindow(true)}
          title={t('profilePage.topUpBalanceBtnText')}
      />;

  const withdrawFundsBtn: ReactElement =
      <Button
          disabled={conditionForBtn}
          onClick={() => setIsOpenWithdrawFundsFormWindow(true)}
          title={t('profilePage.withdrawFundsBtnText')}
          type={ButtonType.SKELETON}
      />;

  const actionWrapper: ReactElement =
      <Tooltip
          action={withdrawFundsBtn}
          text={textForTooltip}
          position="bottom"
      />;

  const currentAction: ReactElement | null =
      ((account?.region === 'CN' || account?.region === 'TR') && (activeTab === 'finTab'))
          ? <>{topUpBalanceBtn}{account?.region === 'CN' ? actionWrapper : null}</>
          : null;

  return (
      <Page
          actions={currentAction}
          title={t('profilePage.title')}
      >
        <div className={styles.tabsRow}>
          <TabsList
              tabs={tabs}
              onChange={setActiveTab}
              value={activeTab}
          />
        </div>
        <TabsContent
            tab={tabs.find((tab) => (tab.id === activeTab))}
        />
        <Modal
            isOpen={isOpenWithdrawFundsFormWindow}
            onClickOverlay={() => setIsOpenWithdrawFundsFormWindow(false)}
            onClose={() => setIsOpenWithdrawFundsFormWindow(false)}
        >
          <WithdrawFundsFormModalWindow
              handlerSetIsOpenWithdrawFundsFormWindow={setIsOpenWithdrawFundsFormWindow}
              refresh={dataRef?.current?.refresh}
              wechatWallets={wechatWallets.data?.items}
          />
        </Modal>
        <Modal
            isOpen={isOpenTopUpBalanceFormWindow}
            onClickOverlay={onCloseBalanceForm}
            onClose={onCloseBalanceForm}
            width={363}
        >
          <TopUpBalanceFormModalWindow
              balanceReplenishmentError={balanceReplenishmentError}
              balanceReplenishmentInProcessed={balanceReplenishmentInProcessed}
              handlerOnCloseBalanceForm={onCloseBalanceForm}
              handlerWaitingBalanceReplenished={waitingBalanceReplenished}
              handlerSetLinkTimeout={setLinkTimeout}
              handlerSetQrTimeout={setQrTimeout}
          />
        </Modal>
        <Modal
            isOpen={isOpenCompletionWindow}
            onClickOverlay={() => setIsOpenCompletionWindow(false)}
            onClose={() => setIsOpenCompletionWindow(false)}
        >
          <CompletionModalWindow
              btnText={t('TopUpBalanceCompletedModalWindow.buttonFinish')}
              handlerSetIsOpenModalWindow={() => setIsOpenCompletionWindow(false)}
              title={t('TopUpBalanceCompletedModalWindow.info', { amount: replenishmentAmount })}
          />
        </Modal>
      </Page>
  );
};

export default ProfilePage;
